<template>
    <span>
        <emc-table-icon
            :disabled="disabled || !gridId"
            :loading="loading"
            icon="mdi-calendar-month-outline"
            :color="color"
            :tool-tip="toolTip"
            @click="open"
        />

        <emc-modal-form
            :title="maskName || 'Datas da grade'"
            :title-tool-tip="maskName"
            icon="mdi-calendar-month-outline"
            maxWidth="600"
            v-bind:show.sync="dialog"
        >
            <template v-slot:form>
                <div v-if="loading" class="text-center py-6">
                    <v-progress-circular indeterminate color="primary" />
                </div>

                <v-alert v-else-if="errorMessage" type="error" dense text>
                    {{ errorMessage }}
                </v-alert>

                <template v-else>
                    <v-simple-table dense>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th>Data</th>
                                <th>Início</th>
                                <th>Fim</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in groupedDates" :key="index">
                                <td>{{ item.date|date }}</td>
                                <td>{{ item.hour_start }}</td>
                                <td>{{ item.hour_end }}</td>
                            </tr>
                            <tr v-if="dates.length === 0">
                                <td colspan="3" class="text-center text--secondary">
                                    Nenhuma data encontrada para esta grade.
                                </td>
                            </tr>
                        </tbody>
                    </template>
                    </v-simple-table>
                </template>
            </template>
        </emc-modal-form>
    </span>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'SysGridDateMasksButton',
    props: {
        gridId: {
            type: [Number, String],
            required: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: 'indigo'
        },
        toolTip: {
            type: String,
            default: 'Datas da grade'
        }
    },
    data: () => ({
        dialog: false,
        loading: false,
        dates: [],
        maskName: null,
        errorMessage: ''
    }),
    computed: {
        groupedDates() {
            var seen = new Set()
            var unique = this.dates.filter((item) => {
                var key = item.date + '|' + item.hour_start + '|' + item.hour_end
                if (seen.has(key)) {
                    return false
                }
                seen.add(key)
                return true
            })

            var sorted = unique.sort((a, b) => {
                if (a.date !== b.date) {
                    return a.date.localeCompare(b.date)
                }
                return a.hour_start.localeCompare(b.hour_start)
            })

            var groups = []

            sorted.forEach((item) => {
                var last = groups[groups.length - 1]

                if (last && last.date === item.date && last.hour_end === item.hour_start) {
                    last.hour_end = item.hour_end
                } else {
                    groups.push({ date: item.date, hour_start: item.hour_start, hour_end: item.hour_end })
                }
            })

            return groups
        }
    },
    watch: {
        dialog(val) {
            if (val) {
                this.fetchDates()
            } else {
                this.dates = []
                this.maskName = null
                this.errorMessage = ''
            }
        }
    },
    methods: {
        ...mapActions('grid', ['ActionFindGridById']),

        open() {
            this.dialog = true
        },

        fetchDates() {
            this.loading = true
            this.errorMessage = ''
            this.dates = []
            this.maskName = null

            this.ActionFindGridById({ id: this.gridId, withDates: true, with: 'dateMaskType' })
                .then((res) => {
                    this.dates = (res.data && res.data.date_masks) ? res.data.date_masks : []
                    this.maskName = (res.data && res.data.date_mask_type) ? res.data.date_mask_type.name : null
                })
                .catch((error) => {
                    this.errorMessage = (error && error.message) ? error.message : 'Falha ao buscar as datas da grade.'
                })
                .finally(() => {
                    this.loading = false
                })
        }
    }
}
</script>
